import { render } from "./tpl-publish.vue?vue&type=template&id=41bf9074&scoped=true"
import script from "./tpl-publish.vue?vue&type=script&lang=js"
export * from "./tpl-publish.vue?vue&type=script&lang=js"

import "./tpl-publish.vue?vue&type=style&index=0&id=41bf9074&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41bf9074"],['__file',"src/views/dragger/template/tpl-publish.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "41bf9074"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('41bf9074', __exports__)) {
    console.log('reload')
    api.reload('41bf9074', __exports__)
  }
  
  module.hot.accept("./tpl-publish.vue?vue&type=template&id=41bf9074&scoped=true", () => {
    console.log('re-render')
    api.rerender('41bf9074', render)
  })

}


export default __exports__